import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";


import styles from "./Step2.module.scss";
import i18n from 'i18n';
import { capitalize } from 'helpers/utils/utils_general';
export class AddEmbalajeStepTwo extends React.Component {
  render() {
    const { embalaje, handleChange, goBack, handleContinue, enableContinue, error } = this.props;
    const stepContent = (
      <form onSubmit={handleContinue}>
      <div className={styles["add-embalaje-wizard-step-two-content"]}>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-measure_height">
          <MainInput
            label={capitalize(i18n.t("measure_height"))+" (cm)"}
            required={true}
            id={"embalaje-measure_height"}
            name="measure_height"
            value={embalaje ? embalaje.measure_height : ''}
            type="number"
            handleChange={handleChange}
            onlyNumbers={"onlyNumbers"}
            positiveNumbers={true}
            maxLength={100}
            error={error.measure_height && error.measure_height}
            />
        </div>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-measure_width">
          <MainInput
              label={capitalize(i18n.t("measure_width"))+" (cm)"}
              required={true}
              id={"embalaje-measure_width"}
              name="measure_width"
              value={embalaje ? embalaje.measure_width : ''}
              type="number"
              handleChange={handleChange}
              onlyNumbers={"onlyNumbers"}
              positiveNumbers={true}
              maxLength={100}
              error={error.measure_width && error.measure_width}

            />
        </div>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-measure_depth">
          <MainInput
              label={capitalize(i18n.t("measure_depth"))+" (cm)"}
              required={true}
              id={"embalaje-measure_depth"}
              name="measure_depth"
              value={embalaje ? embalaje.measure_depth : ''}
              type="number"
              handleChange={handleChange}
              onlyNumbers={"onlyNumbers"}
              positiveNumbers={true}
              maxLength={100}
              error={error.measure_depth && error.measure_depth}

            />
        </div>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-volume">
          <MainInput
            label={i18n.t("volume")+" (cm3)"}
            required={false}
            id={"embalaje-volume"}
            name="volume"
            value={embalaje ? embalaje.volume : ''}
            type="number"
            handleChange={handleChange}
            onlyNumbers={"onlyNumbers"}
            positiveNumbers={true}
            maxLength={100}
            error={error.volume && error.volume}
            />
        </div>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-max_weight">
          <MainInput
              label={i18n.t("maximum.weight")+" (kg)"}
              required={true}
              id={"embalaje-max_weight"}
              name="max_weight"
              value={embalaje ? embalaje.max_weight : ''}
              type="number"
              handleChange={handleChange}
              onlyNumbers={"onlyNumbers"}
              positiveNumbers={true}
              maxLength={100}
              error={error.max_weight && error.max_weight}

            />
        </div>
        <div className={styles["add-embalaje-wizard-step-two-field"]} data-automation-id="input-material">
          <MainInput
              label={i18n.t("material")}
              required={false}
              id={"embalaje-material"}
              name="material"
              value={embalaje ? embalaje.material : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.material && error.material}

            />
        </div>

        <div className={styles["add-embalaje-wizard-step-two-action-wrapper"]}>
          <button type="button" className={`${styles["add-embalaje-wizard-step-two-action-button"]} ${!enableContinue ? styles["disabled"] : ""}`} onClick={enableContinue ? handleContinue : undefined} >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-embalaje-wizard-step-two-container"]}>
        <Step title={i18n.t("packaging.main.step2.title")} goBackFunc={goBack} content={stepContent}></Step>
      </div>
    );
  }
}

export default AddEmbalajeStepTwo;
